import React from 'react';
import { formatDate } from '../../helpers/uiFunctions/uiHelpers';
import { DeleteMonitor } from './MonitorControls';
import MonitorHistory from './MonitorHistory';

class Monitor extends React.Component {
    render() {
        const monitor = this.props.monitor;
        const update = this.props.update;
        const toggleHistory = this.props.toggleHistory;

        return(
            <li id={monitor.id} className={"monitor-row "+monitor.friendly_name +" status-all status-"+ monitor.status} >
                <div>
                    <span className={"status_bar status-"+monitor.status}></span>
                    <DeleteMonitor update={update} monitor={monitor} />
                    <h3>{monitor.friendly_name}</h3><br/>
                    <p><strong>URL:</strong> <a href={monitor.url} target="_blank" rel="noopener noreferrer" style={{display: "inline"}}>{monitor.url}</a></p>
                    <p><strong>Current Status: </strong>
                        {(monitor.status === "0") && ("Paused")}
                        {(monitor.status === "2") && ("Up")}
                        {(monitor.status === "9") && ("Down")}
                    </p>
                    <p><strong>Last 7 Days:</strong> {monitor.custom_uptime_ratio}%</p>
                    <p><strong>All Time:</strong> {monitor.all_time_uptime_ratio}%</p>
                    <br/><p><strong>SSL:</strong> {monitor.ssl.brand}</p>
                    <p><strong>Expires: </strong>{formatDate(monitor.ssl.expires*1000)}</p>
                    <br/>
                    <p><button className="button" onClick={toggleHistory}>Check Status History</button></p>
                    <MonitorHistory monitor={monitor} toggleHistory={toggleHistory} />
                </div>
            </li>
        )
    }
}
export default Monitor;


// WEBPACK FOOTER //
// ./src/component_uptime/components/Monitor.js